export default "__VITE_ASSET__C7yQJQ8i__"